import { render, staticRenderFns } from "./EmptyUnits.vue?vue&type=template&id=155bf0f4&scoped=true&lang=pug"
import script from "./EmptyUnits.vue?vue&type=script&lang=js"
export * from "./EmptyUnits.vue?vue&type=script&lang=js"
import style0 from "./EmptyUnits.styl?vue&type=style&index=0&id=155bf0f4&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155bf0f4",
  null
  
)

export default component.exports